import { getCostCenter } from "@/apis/sap.api";
import { useQuery } from "@tanstack/react-query";

/**
 * 获取成本中心 options
 * @param fdFactory
 * @returns
 */
export const useCostCenterOptions = (fdFactory: string) => {
  const result = useQuery({
    queryKey: ["CostCenterOptions", fdFactory],
    queryFn: () => getCostCenter(fdFactory),
    enabled: !!fdFactory,
  });

  const options =
    result.data?.data.data.map((item) => {
      return {
        label: item.f102,
        value: item.f101,
      };
    }) || [];

  return options;
};
